<template>
    <div class="out-box" v-loading="loadingFlag">
        <div class="inner-box" style="">
            <el-upload
                    drag
                    ref="upload"
                    :action="actionUrl"
                    :data="actionQuery"
                    :on-success="uploadImgSuccess"
                    :show-file-list="false"
                    :on-change="fileChange"
                    :before-upload="beforeAvatarUpload"
                    :limit="1"
                    accept=".jpg,.jpeg,.png,">
                <div class="el-upload__text" style="margin: 60px 0 0 0;color: rgba(0, 0, 0, 0.4)">
                    <p>将文件拖到此处，或<em>点击上传</em></p>
                    <p>只能上传jpg/png文件，且不超过7M</p>
                </div>
            </el-upload>
        </div>
        <label :class="formatClassByType(backgroundType)">
            <img v-if="picShow" :src="imgShow" alt="">
        </label>
        <p v-if="showFileName" class="doc_name_wrapper">
            <em v-if="picShow" class="el-icon-view" @click="openImgPreview"></em>
            <span class="doc_name" @click="openImgPreview()">{{docNameCopy}}</span>
            <span class="deleteIcon"><em class="el-icon-close" @click="delMent()"></em></span>
        </p>
<!--        <loadingTel v-if="loadingFlag" :textType="2" />-->
        <el-dialog
                :title="backgroundTypeTransformation(backgroundType)"
                :visible.sync="centerDialogVisible"
                width="50%"
                class="imgDialogView"
                :show-close="false"
                center>
            <span style="display: flex;align-items: center;justify-content: center">
                 <img ref="rotateImg" v-if="picShow" :src="imgShow" style="width: 90%" alt="">
            </span>
            <div style="display: flex;align-items: center;justify-content: space-between">
                <el-button @click="rotate(0)">左旋转</el-button>
                <el-button @click="rotate(1)">右旋转</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {isIEBrowser} from '@/utils/index'
    export default {
        props: {
            fileItem: {
                type: Object,
                required: true
            },
            backgroundType: {
                type: Number,
            },
            ruleForm: {
                type: Object
            }
        },
        watch:{
            fileItem(val){
                this.$emit('update:fileItem',val)
            },
        },

        computed:{
            docNameCopy: {
                get () {
                    return this.fileItem.name
                }
            },
            showFileName: {
                get () {
                    return this.docNameCopy != ''
                }
            },
        },

        data() {
            return {
                loadingFlag:false,
                centerDialogVisible:false,
                actionUrl: '',
                actionQuery: {},//action参数
                picShow: '',
                imgShow: '',
                fileInfo:{
                    deg:0
                }
            }
        },
        created() {
            this.actionUrl = process.env.VUE_APP_ssoLogin == 'true'?'/appentinfo':'proxyApi'+ '/attachment/uploadFile';
        },
        mounted(){
            this.$nextTick(()=>{
                if(this.fileItem.filePath){
                    this.getImgUrl(this.fileItem.filePath);
                }
            })
        },
        methods: {
            //backgroundType 图片上传组件背景参数 1-> 营业执照 2-> 身份证正面 3-> 身份证反面 4-> 基本户扫描件 5-> 资质证书
            formatClassByType(type){
                switch(type){
                    case 1 : return 'show-img do-business' ; break;
                    case 2 : return 'show-img id-card-another' ; break;
                    case 3 : return 'show-img id-card-positive' ; break;
                    case 4 : return 'show-img basic-scanning' ; break;
                    case 5 : return 'show-img qualification-certificate' ; break;
                    default : return '' ; break;
                }

            },
            delMent() {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {

                    if (this.fileItem.id){
                        this.$mainHttp.get("/attachment/delattachmentbyid?id=" + this.fileItem.id,{}).then((res)=>{
                            if (res.data.code == 1){
                                this.deleteMes()
                            }
                        })
                    }else {
                        this.deleteMes()
                    }

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },

            deleteMes(){


                this.fileItem.name= '';
                this.fileItem.id='';
                this.fileItem.filePath='';
                this.imgShow = "";
                this.picShow = false;
                this.$emit('update:fileItem', this.fileItem);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            },


            getImgUrl(filePath){

                this.$mainHttp({
                    method: 'get',
                    url: '/sys/upload/downfile?filePath=' + encodeURI(filePath),
                    responseType: 'blob'
                }).then(res => {
                    var typeName = filePath.split(".")[1];
                    let blob = new Blob([res.data], {type: 'application/' + typeName + ''})
                    this.imgShow = window.URL.createObjectURL(blob);
                    this.picShow = true;
                })

            },
            beforeAvatarUpload(file){
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                const isPG = (isJPG || isPNG)                                       //限制图片格式为jpg / png
                const isLt7M = file.size / 1024 / 1024 < 6;                         //限制图片大小
                // const isSize = new Promise(function(resolve,reject) {
                //     let width = 600
                //     let height = 400
                //     let _URL = window.URL || window.webkitURL
                //     let img = new Image()
                //     img.onload = function() {
                //         let valid = img.width >= width && img.height >= height
                //         valid ? resolve() : reject();
                //     }
                //     img.src = _URL.createObjectURL(file)
                // }).then(() => {
                //     return file;
                // },()=>{
                //     this.$message.error('上传图片像素要大于600*400!');
                //     return promise.reject();
                // })
                if (!isPG) {
                    this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
                }
                if (!isLt7M) {
                    this.$message.error('上传头像图片大小不能超过 7MB!');
                }

                this.loadingFlag = isPG && isLt7M;

                this.fileUploadToOcr(file)

                return isPG && isLt7M
            },

            // 文件上传OCR
            fileUploadToOcr(file){

                let fd = new FormData();
                fd.append('xlsFile', file);
                if (this.backgroundType == 1) { //判断为营业执照
                    this.$mainHttp.post('/ocr/getBizLicenseOCR', fd).then(res => {
                        if (res.data.code == 1) {
                            let data = res.data.data;
                            this.ruleForm.certNum = data.certNum;
                            this.ruleForm.businessFailTime = data.businessFailTime.replace(/-/g,'/');
                            this.ruleForm.registerCapital = data.registerCapital;
                            this.ruleForm.incorporationTime = data.incorporationTime.replace(/-/g,'/');
                            this.ruleForm.addressDetail = data.address;
                            this.ruleForm.businessScope = data.businessScope;
                            this.ruleForm.certName = data.entName;
                            this.ruleForm.companyType = data.unitProperty;
                        }else{
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            })
                        }
                    })
                }

                if(this.backgroundType == 3){//判断为身份证
                    this.$mainHttp.post('/ocr/getIdCardOCR', fd).then(res => {
                        if (res.data.code == 1) {
                            let data = res.data.data;
                            this.ruleForm.orgLegal = data.name ? data.name : '';
                            this.ruleForm.legalIdCard = data.idNum ? data.idNum : '';
                            if(this.ruleForm.entContactVo){
                                this.ruleForm.entContactVo.orgLegal = data.name ? data.name : '';
                                this.ruleForm.entContactVo.legalIdCard = data.idNum ? data.idNum : '';
                            }
                        }else{
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            })
                        }
                    })
                }

                if(this.backgroundType == 4){//判断为基本户扫描件
                    this.$mainHttp.post('/ocr/getIdBankCardOCR', fd).then(res => {
                        if (res.data.code == 1) {
                            let data = res.data.data;
                            this.ruleForm.bankInfoType = data.bankInfoType ? data.bankInfoType : '';
                            this.ruleForm.accountNumber = data.certNum ? data.certNum : '';
                            if(this.ruleForm.entBankInfoVo){
                                this.ruleForm.entBankInfoVo.bankInfoType = data.bankInfoType ? data.bankInfoType : '';
                                this.ruleForm.entBankInfoVo.accountNumber = data.certNum ? data.certNum : '';
                            }
                        }else{
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            })
                        }
                    })
                }

                if(this.backgroundType == 5){//判断为资质证书
                    this.$mainHttp.post('/ocr/getEnterpriseLicenseOCR',fd).then(res => {
                        if(res.data.code == 1){
                            let data = res.data.data;
                            this.ruleForm.certNo = data.certNo ? data.certNo : '';
                            this.ruleForm.qualificationValidityEnd = data.qualificationValidityEnd ? data.qualificationValidityEnd : '';
                            this.ruleForm.sendTime = data.sendTime ? data.sendTime : '';
                        }else{
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            })
                        }
                    })
                }
                this.$emit('update:ruleForm', this.ruleForm);//更新父组件视图

            },
            //上传触发
            fileChange(file) {
                this.actionQuery.xlsFile = file.raw;
                this.actionQuery.table = 'basic';
                if(isIEBrowser()){
                    this.actionQuery.ieUpload = true;
                }
            },
            //上传成功
            uploadImgSuccess(file) {
                if (file.code == 1) {
                    this.loadingFlag = false;
                    this.$refs.upload.clearFiles(); //去掉文件列表
                    this.fileItem.filePath = file.data.filepath;
                    this.fileItem.name = file.data.name;
                    this.$emit('update:fileItem',this.fileItem)
                    this.$emit('uploadSuccess', this.fileItem.fileType);
                    this.$message({
                        message: '图片上传成功',
                        type: 'success'
                    })
                    this.getImgUrl(file.data.filepath)
                }else{
                    this.$message({
                        message: '图片上传失败',
                        type: 'error'
                    })
                }
            },
            openImgPreview(){
                this.centerDialogVisible = true;
            },
            //backgroundType 图片上传组件背景参数 1-> 营业执照 2-> 身份证正面 3-> 身份证反面 4-> 基本户扫描件 5-> 资质证书
            backgroundTypeTransformation(val){
                switch(val){
                    case 1 : return '营业执照' ; break;
                    case 2 : return '身份证正面' ; break;
                    case 3 : return '身份证反面' ; break;
                    case 4 : return '基本户扫描件' ; break;
                    case 5 : return '资质证书' ; break;
                    default : return '' ; break;
                }
            },
            rotate (val) {
                if(val == 0){
                    console.log('left')
                    this.fileInfo.deg -= 90;
                    if (this.fileInfo.deg <= -360) {
                        this.fileInfo.deg = 0
                    }
                }else{
                    this.fileInfo.deg += 90;
                    if (this.fileInfo.deg >= 360) {
                        this.fileInfo.deg = 0
                    }

                }
                this.$refs.rotateImg.style.transform = `rotate(${this.fileInfo.deg}deg)`;
                // this.$refs.rotateImg.style.width = '70%';
                // this.$refs.rotateImg.style.height = '70%';
            }
        },
    }
</script>
<style>
    .imgDialogView .el-dialog{
        background: inherit;
        box-shadow: none;
    }
</style>
<style lang="scss" scoped>
    /deep/.el-upload-dragger{
        width: 300px;
        height: 186px;
        background: rgba(255,255,255,0);
        .is-dragover{
            background: rgba(0, 0, 0, 0.3);
        }
    }
    .out-box {
        width: 300px;
        height: 186px;
        position: relative;
        margin: 0 0 28px 0;
        .inner-box {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            /*opacity: 0.3;*/
            z-index: 90;
        }
        .inner-box:hover{
            background: rgba(0, 0, 0, 0.3);
        }
        .show-img {
            display: inline-block;
            width: 300px;
            height: 186px;
            cursor: pointer;
            position: absolute;
            top: 0;
            img {
                width: 100%;
                height: 100%;
            }
        }

        .do-business {
            background: url("../../assets/img/yingyezhizhao.png") no-repeat center center;
        }

        .id-card-positive {
            background: url("../../assets/img/id-card-positive.png") no-repeat center center;
        }

        .id-card-another {
            background: url("../../assets/img/id-card-another.png") no-repeat center center;
        }

        .basic-scanning {
            background: url("../../assets/img/basic-scanning.png") no-repeat center center;
        }

        .qualification-certificate {
            background: url("../../assets/img/qualification-certificate.png") no-repeat center center;
            background-size: 100% 100%;
        }

        p.doc_name_wrapper{
            width: 100%;
            height: 30px;
            line-height: 28px;
            position: absolute;
            bottom: -40px;
            cursor: pointer;
            border-bottom: 1px solid #dcdfe6;
            .doc_name{
                margin-left: 6px;
                display: inline-block;
                border-bottom: 1px solid #1890FF;
                position: relative;bottom: -1px
            }
            .deleteIcon{
                position: absolute;
                right:0;
            }
        }


    }

    @media screen and (max-width: 1600px){
        .out-box{
            width: 236px;
            height: 140px;
            .show-img{
                width: 236px;
                height: 140px;
            }
            /deep/.el-upload-dragger{
                width: 236px;
                height: 140px;
            }
        }
    }


</style>